import { useSettings } from "@/context/SettingsContext";
import { useSeo } from "@/lib/useSeo";
import { PublicLayout } from "@/components/site/PublicLayout";

export default function PrivacyPolicy() {
  const settings = useSettings();
  const c = settings?.contact || {};
  useSeo({ title: "Privacy Policy | Adv. Guruvayoorappan K V", description: "Privacy policy for the website of Adv. Guruvayoorappan K V, Advocate, Thrissur.", robots: "index, follow" });
  return (
    <PublicLayout hideFooterCTA>
      <section className="bg-navy py-14"><div className="max-w-4xl mx-auto px-4 sm:px-6"><h1 className="font-serif text-4xl lg:text-5xl text-ivory">Privacy Policy</h1></div></section>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-14 prose-legal" data-testid="privacy-content">
        <p>This Privacy Policy explains how information submitted through this website is handled.</p>
        <h2>Information We Collect</h2>
        <p>When you submit an enquiry through the contact form, we collect the information you provide, which may include your name, phone number, email address and the message describing your legal matter.</p>
        <h2>How We Use Your Information</h2>
        <p>The information you provide is used solely to respond to your enquiry and to discuss your legal matter. We do not sell or rent your personal information to third parties.</p>
        <h2>Cookies & Analytics</h2>
        <p>This website may use cookies and analytics tools to understand website usage and improve the experience. Analytics are only enabled if configured by the administrator.</p>
        <h2>Data Security</h2>
        <p>Enquiries are stored securely in a backend database. Reasonable measures are taken to protect the information you submit.</p>
        <h2>Data Retention</h2>
        <p>Enquiry data is retained only for as long as necessary to respond to and manage your enquiry.</p>
        <h2>Contact Regarding Privacy</h2>
        <p>For any questions about this Privacy Policy or your data, please contact the office. Office: {c.address}. Phone: {c.phone1}, {c.phone2}.</p>
      </div>
    </PublicLayout>
  );
}
